import { matchHeights } from './matchHeights';
export const asyncLoadMorePosts = () => {
    let page = 1;
    let loading = false;
    const container = document.querySelector('.posts__container');
    const loadMoreBtn = document.querySelector('.posts__load-more');
    if(loadMoreBtn){
        loadMoreBtn.addEventListener('click', () => {
            if (!loading) {
                loading = true;
                loadMoreBtn.textContent = 'Ładowanie...';
                page++;
    
                fetch(mainUrl+'/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'load_more_posts',
                        page: page,
                        // add any other data you need to pass
                    }),
                })
                .then(response => response.text())
                .then(data => {
                    if (data.trim() === '') {
                        // If no more posts are returned, mark all posts as loaded
                        loadMoreBtn.style.display="none";
                    } else {
                        // Append new posts directly to the container
                        const initialHeight = container.offsetHeight;
    
                        // Append new posts directly to the container
                        container.insertAdjacentHTML('beforeend', data);
    
                        // Get the height of the container after adding new posts
                        const finalHeight = container.offsetHeight;
    
                        // Animate the height change of the container
                        animateHeightChange(container, initialHeight, finalHeight);
    
                        loadMoreBtn.textContent = 'Zobacz więcej';
                        matchHeights();
                        if (data.split('posts__post').length < 8) {
                            loadMoreBtn.style.display = 'none';
                        }
                    }
                    loading = false;
                })
                .catch(error => {
                    console.error('Error:', error);
                    loading = false;
                    loadMoreBtn.textContent = 'Zobacz więcej';
                });
            }
        });
    }

}
function animateHeightChange(element, initialHeight, finalHeight, duration = 600) {
    const startTime = performance.now();
    const parentElement = element.parentElement;

    const easeOutCubic = t => 1 - Math.pow(1 - t, 3); // Easing function

    const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easedProgress = easeOutCubic(progress); // Apply easing function
        const newHeight = initialHeight + (finalHeight - initialHeight) * easedProgress;
        element.style.height = newHeight + 'px';

        // Continue the animation until the duration is reached
        if (elapsedTime < duration) {
            requestAnimationFrame(animate);
        } else {
            // Animation complete, remove overflow:hidden from parent
            parentElement.style.overflow = '';
        }
    };

    // Explicitly set the container's height before starting the animation
    element.style.height = initialHeight + 'px';
    
    // Add overflow: hidden to parent element during animation
    parentElement.style.overflow = 'hidden';

    requestAnimationFrame(animate);
}